<template>
  <div class="home">
    <v-app>
      <v-app-bar app>
        <v-row class="pt-5">
          <v-col cols="9" justify="center">
            <v-text-field
              label="Search.."
              outlined
              dense
              clearable
              v-model="searchText"
              @input="resultQuery"
              background-color="white"
            ></v-text-field>
          </v-col>
          <v-col class="mt-2 px-0" cols="1" justify="center">
            <v-dialog
              v-model="scanDialog"
              transition="dialog-bottom-transition"
              max-width="90%"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn v-bind="attrs" v-on="on" width="10" x-small>
                  <v-icon>mdi-barcode-scan</v-icon>
                </v-btn>
              </template>
              <template v-slot:default="dialog">
                <v-card class="justify-center" height="600">
                  <v-toolbar color="dark-grey" dark>
                    <v-row>
                      <v-col md="10" class="my-3"> Scan Barcode </v-col>
                      <v-col md="1" align="right">
                        <v-btn icon @click="dialog.value = false"
                          ><v-icon>mdi-close</v-icon></v-btn
                        >
                      </v-col>
                    </v-row>
                  </v-toolbar>
                  <scanner
                    v-if="scanDialog"
                    
                    v-on:close-dialog="closeDialog"
                   @interface="getChildInterface"
                  ></scanner>
                  
                  <v-card-actions class="justify-end">
                    <v-btn text @click="dialog.value = false">Close</v-btn>
                  </v-card-actions>
                </v-card>
              </template>
            </v-dialog>
          </v-col>
          <!-- <v-col class="">
            <p>Login as : {{ nama }}</p>
          </v-col> -->
          <v-col align="right" cols="1" justify="center" class="mt-2 px-2">
            <v-btn @click="logout" x-small><v-icon>mdi-logout</v-icon></v-btn>
          </v-col>
        </v-row>
      </v-app-bar>

      <v-main>
         
          <v-container class="mx-5" block>
            
            <v-row dense>
              <v-col
                v-for="product in products"
                :key="product.id"
                md="3"
                lg="3"
                @click="openDialogEdit(product.id)"
              >
                <v-card
                  class="px-0 py-0 mx-0"
                  width="300px"
                  height="400px"
                  elevation="5"
                >
                  <v-card-title class="font-weight-bold">{{
                    product.sku
                  }}</v-card-title>
                  <v-container class="py-0">
                    <v-row>
                      <v-col class="py-0">Nama :</v-col>
                    </v-row>
                    <v-row class="pb-2">
                      <v-col class="py-0 font-weight-bold">{{
                        product.nama
                      }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">Brand :</v-col>
                    </v-row>
                    <v-row class="pb-2">
                      <v-col class="py-0 font-weight-bold">{{
                        product.brand
                      }}</v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">HET New :</v-col>
                    </v-row>
                    <v-row class="pb-2">
                      <v-col class="py-0 font-weight-bold">
                          {{product.HET_NEW == null ? null : parseInt(product.HET_NEW).toLocaleString('en-US')}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">Harga Jual:</v-col>
                    </v-row>
                    <v-row class="pb-2">
                      <v-col class="py-0 font-weight-bold">
                        {{product.HrgJual == null ? null : parseInt(product.HrgJual).toLocaleString('en-US')}}
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col class="py-0">Jenis motor :</v-col>
                    </v-row>
                    <v-row class="pb-2">
                      <v-col class="py-0 font-weight-bold">
                        <div v-if="!product.JenisMotor">
                        </div>
                        <div v-else>
                          <div v-if="product.JenisMotor.length < 50">
                            {{ product.JenisMotor }}
                          </div>
                          <div v-else>
                            {{ product.JenisMotor.substring(0, 50) + "..." }}
                          </div>
                        </div>
                        
                      </v-col>
                    </v-row>

                    <!-- <p>{{product.JenisMotor}} </p> -->
                  </v-container>
                </v-card>
              </v-col>
            </v-row>
            <v-row>
              <v-col> </v-col>
            </v-row>
          </v-container>
          <div  > 
          <!-- <v-img width="20%" class="mx-auto my-50" src="/img/Loading_2.gif" alt=""/> -->
          
        </div>
        <v-dialog
          v-model="addDialog"
          transition="dialog-bottom-transition"
          max-width="600"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="dark-grey"
              fixed
              bottom
              right
              fab
              dark
              elevation="10"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <template>
            <v-card class="justify-center" flat>
              <v-toolbar color="dark-grey" dark>
                <v-row>
                  <v-col md="10" class="my-3">{{ this.title }} Barang </v-col>
                  <v-col align="right">
                    <v-btn icon @click="closeAddDialog"
                      ><v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-toolbar>
              <barang-detail
                v-on:close-add-dialog="closeAddDialog"
                :title="title"
              ></barang-detail>
              <v-card-actions class="justify-end">
                <v-btn text @click="closeAddDialog">Close</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
        <v-dialog
          v-model="filterDialog"
          transition="dialog-bottom-transition"
          max-width="600"
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              color="dark-grey"
              fixed
              small
              top
              right
              fab
              dark
              elevation="3"
              class="mt-15"
              v-bind="attrs"
              v-on="on"
            >
              <v-icon>mdi-filter-variant-plus</v-icon>
            </v-btn>
          </template>
          <template>
            <v-card class="justify-center">
              <v-toolbar color="dark-grey" dark>
                <v-row>
                  <v-col md="10" class="my-3"> Filter </v-col>
                  <v-col md="1" align="right">
                    <v-btn icon @click="closeFilterDialog"
                      ><v-icon>mdi-close</v-icon></v-btn
                    >
                  </v-col>
                </v-row>
              </v-toolbar>
              <!-- isi filter -->
              <v-combobox
                v-model="filterBrand"
                :items="itemBrand"
                label="Select Brand"
                class="mx-5"
                multiple
              ></v-combobox>
              <v-card-actions class="justify-end">
                <v-btn text @click="closeFilterDialog">Close</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
        <v-dialog 
          v-model="isLoading"
          transition="dialog-bottom-transition"
          width="100%"
          height="100%">
          <v-template >
            <v-card class="justify-center">
              <v-img width="20%" class="mx-auto my-50" src="/img/Loading_2.gif" alt=""/>
            </v-card>
          </v-template>
        </v-dialog>
      </v-main>
     
    </v-app>
  </div>
  
</template>

<script>
import api from "@/services/http";

import scanner from "../components/Scanner.vue";
import BarangDetail from "../components/DetailBarang.vue";


// import { StreamBarcodeReader } from "vue-barcode-reader";

export default {
  name: "home",
  components: { 
     scanner, 
    BarangDetail },
  data() {
    return {
      isLoading: true,
      nama: "",
      token: "",
      title: "Add",
      componentLoaded: false,
      searchText: "",
      products: [],
      fullData: [],
      scanDialog: false,
      addDialog: false,
      filterDialog: false,
      rightDrawer: false, 
      filterBrand: [],
      itemBrand: ["ASPIRA", "YAMAHA", "HONDA", "FEDERAL"],
    };
  },
  created() {
    // this.nama = this.$route.params.nama;
    // this.token = this.$route.params.token;
    document.title = "Berkat Motor";     
    this.nama = localStorage.nama;
    //this.token = localStorage.token;

    if (localStorage.token) {
      this.token = localStorage.token;
      //alert("Anda mengakses halaman Backend dengan token : " + "\n\n" + token);
      this.getBarang();
    } else {
      this.$router.push({
        name: "login",
      });
    }

    
  },
  childInterface: {
    closeStream: () => {},
  },
  methods: {
    getBarang() {
      this.isLoading=true;

      api
        .get("/barangs?token=" + this.token)
        .then((res) => {
          console.log(res.data);
          //'kode', 'sku', 'nama', 'brand','JenisMotor','HET','HET_NEW','kenaikan','HrgJual','Stok','HrgBeli','keterangan'
          this.products = res.data;
          this.fullData = res.data;
          self.componentLoaded = true;
        })
        .catch((err) => {
          if (err == "Error: Request failed with status code 500") {
            alert("koneksi database bermasalah");
            //console.log(res.data);
            this.$router.push("/");
          } else {
            console.log("error : ");
            // console.log(res.data);
          }
        });
        this.isLoading=false;

    },
    resultQuery() {
      console.log("search start");
      console.log(this.searchText);
      console.log(this.filterBrand);
      this.isLoading=true;

      if (this.searchText || this.filterBrand.length > 0) {
        var parTxt = this.searchText == null ? null : this.searchText.trim();
        if (!parTxt) {
          parTxt = this.filterBrand[0];
        }

        // this.products = this.fullData;
        // this.products = this.products.filter((item) => {
        //   // 'kode', 'sku', 'nama', 'brand','JenisMotor','HET','HET_NEW','kenaikan','keterangan'
        //   return (
        //     item.kode.toLowerCase().includes(this.searchText.toLowerCase()) ||
        //     item.nama.toLowerCase().includes(this.searchText.toLowerCase()) ||
        //     item.sku.toLowerCase().includes(this.searchText.toLowerCase()) ||
        //     item.brand.toLowerCase().includes(this.searchText.toLowerCase()) ||
        //     item.JenisMotor.toLowerCase().includes(
        //       this.searchText.toLowerCase()
        //     ) ||
        //     item.keterangan
        //       .toLowerCase()
        //       .includes(this.searchText.toLowerCase())
        //   );
        // });
        api
          .post("/search/" + parTxt + "?token=" + this.token, {
            fbrand: this.filterBrand,
          })
          .then((res) => {
            console.log(res.data);
            //'kode', 'sku', 'nama', 'brand','JenisMotor','HET','HET_NEW','kenaikan','HrgJual','Stok','HrgBeli','keterangan'
            this.products = res.data;
            self.componentLoaded = true;
          })
          .catch((err) => {
            if (err == "Error: Request failed with status code 500") {
              alert("koneksi database bermasalah");
              //console.log(res.data);
              this.$router.push("/");
            } else {
              console.log("error : ");
              // console.log(res.data);
            }
          });
        console.log(this.products);
      } else {
        this.products = this.fullData;
      }
      this.isLoading=false;

      console.log(this.isLoading);
    },
    closeDialog(txt) {
      console.log("home close");

      this.searchText = txt ==null ? null : txt.trim();
      this.scanDialog = false;
      this.$options.childInterface.closeStream();
      localStorage.isStream = false;
      console.log(this.searchText);
      console.log(localStorage.searchTxt);
      this.resultQuery();
    },
    closeAddDialog() {
      console.log("detail close");
      this.addDialog = false;
      localStorage.brgEditID = null;
      this.title = "Add";
      this.resultQuery();
    },
    closeFilterDialog() {
      console.log("detail close");
      this.filterDialog = false;
      this.resultQuery();
    },
    logout() {
      api.get("logout?token=" + this.token).then((res) => {
        console.log(res);
        this.$router.push("/");
      });
    },
    openDialogEdit(id) {
      localStorage.brgEditID = id;
      console.log(localStorage.brgEditID);
      this.title = "Edit";
      this.addDialog = true;
    },
    getChildInterface(childInterface) {
        this.$options.childInterface = childInterface;
      },
  },
  monunted: {
    // mounted() {
    //   console.log("mounted start");
    //   this.resultQuery();
    // },
    
  },
  computed: {},
  watch: {
    scanDialog() {
      if(!this.scanDialog && localStorage.searchTxt == "") 
        this.closeDialog("");
    }
  },
};
</script>
